<template>
  <div class="user-list">
    <div class="header">
      <h2>用户管理</h2>
      <el-button type="primary" @click="showCreateDialog">新增用户</el-button>
    </div>
    
    <div class="filter-section">
      <el-form :inline="true" :model="filterForm" class="filter-form">
        <el-form-item label="角色">
          <el-select v-model="filterForm.role" placeholder="请选择角色" clearable>
            <el-option label="管理员" value="admin"></el-option>
            <el-option label="普通用户" value="user"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="filterForm.status" placeholder="请选择状态" clearable>
            <el-option label="启用" :value="1"></el-option>
            <el-option label="禁用" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="关键词">
          <el-input v-model="filterForm.keyword" placeholder="用户名/姓名/手机号" clearable style="width: 200px;"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="loadList">查询</el-button>
          <el-button @click="resetFilter">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    
    <div class="table-section">
      <el-table
        :data="tableData"
        border
        stripe
        v-loading="loading"
        style="width: 100%">
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column prop="username" label="用户名" min-width="120"></el-table-column>
        <el-table-column prop="realName" label="真实姓名" min-width="120"></el-table-column>
        <el-table-column prop="phone" label="手机号" min-width="120"></el-table-column>
        <el-table-column prop="email" label="邮箱" min-width="150"></el-table-column>
        <el-table-column prop="role" label="角色" width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.role === 'admin'" type="danger">管理员</el-tag>
            <el-tag v-else type="info">普通用户</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status === 1" type="success">启用</el-tag>
            <el-tag v-else type="danger">禁用</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createdAt" label="创建时间" min-width="180">
          <template slot-scope="scope">
            {{ formatDate(scope.row.createdAt) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="280" fixed="right">
          <template slot-scope="scope">
            <el-button type="primary" size="small" @click="editUser(scope.row)">编辑</el-button>
            <el-button type="warning" size="small" @click="resetPassword(scope.row)">重置密码</el-button>
            <el-button type="danger" size="small" @click="deleteUser(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <div class="pagination-section">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total">
        </el-pagination>
      </div>
    </div>

    <!-- 新增/编辑对话框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="600px"
      @close="resetForm">
      <el-form :model="formData" :rules="formRules" ref="userForm" label-width="100px">
        <el-form-item label="用户名" prop="username" v-if="!isEdit">
          <el-input v-model="formData.username" placeholder="请输入用户名（3-50个字符）"></el-input>
        </el-form-item>
        <el-form-item label="用户名" v-else>
          <el-input v-model="formData.username" disabled></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password" v-if="!isEdit">
          <el-input v-model="formData.password" type="password" placeholder="请输入密码（至少6个字符）" show-password></el-input>
        </el-form-item>
        <el-form-item label="真实姓名" prop="realName">
          <el-input v-model="formData.realName" placeholder="请输入真实姓名"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="formData.phone" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="formData.email" placeholder="请输入邮箱"></el-input>
        </el-form-item>
        <el-form-item label="角色" prop="role">
          <el-select v-model="formData.role" placeholder="请选择角色" style="width: 100%;">
            <el-option label="管理员" value="admin"></el-option>
            <el-option label="普通用户" value="user"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="formData.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="formData.remark" type="textarea" :rows="3" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm" :loading="submitting">确定</el-button>
      </div>
    </el-dialog>

    <!-- 重置密码对话框 -->
    <el-dialog
      title="重置密码"
      :visible.sync="passwordDialogVisible"
      width="400px">
      <el-form :model="passwordForm" :rules="passwordRules" ref="passwordForm" label-width="100px">
        <el-form-item label="用户名">
          <el-input v-model="passwordForm.username" disabled></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input v-model="passwordForm.newPassword" type="password" placeholder="请输入新密码（至少6个字符）" show-password></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="passwordDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitPassword" :loading="submitting">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'UserList',
  data() {
    // 验证手机号
    const validatePhone = (rule, value, callback) => {
      if (value && !/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    }
    // 验证邮箱
    const validateEmail = (rule, value, callback) => {
      if (value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        callback(new Error('请输入正确的邮箱地址'))
      } else {
        callback()
      }
    }

    return {
      loading: false,
      submitting: false,
      tableData: [],
      filterForm: {
        role: null,
        status: null,
        keyword: ''
      },
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      dialogVisible: false,
      dialogTitle: '新增用户',
      isEdit: false,
      formData: {
        username: '',
        password: '',
        realName: '',
        phone: '',
        email: '',
        role: 'user',
        status: 1,
        remark: ''
      },
      formRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 3, max: 50, message: '用户名长度为3-50个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 50, message: '密码长度为6-50个字符', trigger: 'blur' }
        ],
        phone: [
          { validator: validatePhone, trigger: 'blur' }
        ],
        email: [
          { validator: validateEmail, trigger: 'blur' }
        ],
        role: [
          { required: true, message: '请选择角色', trigger: 'change' }
        ]
      },
      passwordDialogVisible: false,
      passwordForm: {
        userId: null,
        username: '',
        newPassword: ''
      },
      passwordRules: {
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, max: 50, message: '密码长度为6-50个字符', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    this.loadList()
  },
  methods: {
    loadList() {
      this.loading = true
      const params = {
        page: this.pagination.page,
        pageSize: this.pagination.pageSize
      }
      if (this.filterForm.role !== null && this.filterForm.role !== '') {
        params.role = this.filterForm.role
      }
      if (this.filterForm.status !== null && this.filterForm.status !== '') {
        params.status = this.filterForm.status
      }
      if (this.filterForm.keyword) {
        params.keyword = this.filterForm.keyword
      }
      
      this.$http.get('/User/list', { params })
        .then(res => {
          this.loading = false
          if (res.data.success) {
            this.tableData = res.data.data.list
            this.pagination.total = res.data.data.total
          } else {
            this.$message.error(res.data.message || '查询失败')
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('网络错误，请重试')
        })
    },
    resetFilter() {
      this.filterForm = {
        role: null,
        status: null,
        keyword: ''
      }
      this.pagination.page = 1
      this.loadList()
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.pagination.page = 1
      this.loadList()
    },
    handleCurrentChange(val) {
      this.pagination.page = val
      this.loadList()
    },
    showCreateDialog() {
      this.dialogTitle = '新增用户'
      this.isEdit = false
      this.dialogVisible = true
    },
    editUser(row) {
      this.dialogTitle = '编辑用户'
      this.isEdit = true
      this.formData = {
        id: row.id,
        username: row.username,
        realName: row.realName || '',
        phone: row.phone || '',
        email: row.email || '',
        role: row.role,
        status: row.status,
        remark: row.remark || ''
      }
      this.dialogVisible = true
    },
    submitForm() {
      this.$refs.userForm.validate((valid) => {
        if (!valid) {
          return false
        }
        
        this.submitting = true
        if (this.isEdit) {
          // 更新用户
          const updateData = {
            realName: this.formData.realName || null,
            phone: this.formData.phone || null,
            email: this.formData.email || null,
            role: this.formData.role,
            status: this.formData.status,
            remark: this.formData.remark || null
          }
          
          this.$http.put(`/User/${this.formData.id}`, updateData)
            .then(res => {
              this.submitting = false
              if (res.data.success) {
                this.$message.success('更新成功')
                this.dialogVisible = false
                this.loadList()
              } else {
                this.$message.error(res.data.message || '更新失败')
              }
            })
            .catch(err => {
              this.submitting = false
              this.$message.error('网络错误，请重试')
            })
        } else {
          // 创建用户
          this.$http.post('/User/create', this.formData)
            .then(res => {
              this.submitting = false
              if (res.data.success) {
                this.$message.success('创建成功')
                this.dialogVisible = false
                this.loadList()
              } else {
                this.$message.error(res.data.message || '创建失败')
              }
            })
            .catch(err => {
              this.submitting = false
              this.$message.error('网络错误，请重试')
            })
        }
      })
    },
    resetForm() {
      this.$refs.userForm && this.$refs.userForm.resetFields()
      this.formData = {
        username: '',
        password: '',
        realName: '',
        phone: '',
        email: '',
        role: 'user',
        status: 1,
        remark: ''
      }
    },
    resetPassword(row) {
      this.passwordForm = {
        userId: row.id,
        username: row.username,
        newPassword: ''
      }
      this.passwordDialogVisible = true
    },
    submitPassword() {
      this.$refs.passwordForm.validate((valid) => {
        if (!valid) {
          return false
        }
        
        this.submitting = true
        this.$http.post(`/User/${this.passwordForm.userId}/reset-password`, {
          newPassword: this.passwordForm.newPassword
        })
          .then(res => {
            this.submitting = false
            if (res.data.success) {
              this.$message.success('密码重置成功')
              this.passwordDialogVisible = false
            } else {
              this.$message.error(res.data.message || '密码重置失败')
            }
          })
          .catch(err => {
            this.submitting = false
            this.$message.error('网络错误，请重试')
          })
      })
    },
    deleteUser(row) {
      this.$confirm(`确定要删除用户 "${row.username}" 吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.delete(`/User/${row.id}`)
          .then(res => {
            if (res.data.success) {
              this.$message.success('删除成功')
              this.loadList()
            } else {
              this.$message.error(res.data.message || '删除失败')
            }
          })
          .catch(err => {
            this.$message.error('网络错误，请重试')
          })
      }).catch(() => {})
    },
    formatDate(dateStr) {
      if (!dateStr) return ''
      const date = new Date(dateStr)
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      })
    }
  }
}
</script>

<style scoped>
.user-list {
  padding: 20px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.header h2 {
  font-size: 24px;
  color: #333;
  margin: 0;
}

.filter-section {
  background: #fff;
  padding: 20px;
  margin-bottom: 20px;
  border-radius: 4px;
}

.table-section {
  background: #fff;
  padding: 20px;
  border-radius: 4px;
}

.pagination-section {
  margin-top: 20px;
  text-align: right;
}
</style>
